import useIntls from '@opm/hooks/useIntls';
import TableMiniChart from '@opm/components/TableMiniChart';
import React, { useMemo } from 'react';
import { DBO_ARR, DBO_V } from '@op/utils/format';
import './index.scss';

export default function MinChart({
  timeline,
}: {
  timeline: Array<{ time: string; value: number }>;
}) {
  const { intl } = useIntls();

  const data = useMemo(() => {
    timeline.sort(DBO_ARR.sortByTime('time', 'asc'));
    return {
      timeline,
      timeline_of_start_time: timeline?.[0]?.time,
      timeline_of_end_time: timeline?.[timeline.length - 1]?.time,
    };
  }, [timeline]);

  return (
    <TableMiniChart
      name={intl('Trend')}
      className="dbo-min-chart-wrapper"
      data={data}
      valueKey={'value'}
      showTooltip={false}
      valueFormat={(val) => DBO_V.percentageFormat(val * 100, '0', 0)}
    ></TableMiniChart>
  );
}
